import { Component } from "react";

// Збій рендеру не повинен лишати порожню сторінку: показуємо, що сталося, і даємо продовжити.
// Перехід на інший розділ (зміна hash) скидає помилку — решта застосунку працює далі.
// page — зовнішній рубіж (вся сторінка, без шапки); без нього — вміст під шапкою, меню лишається
export default class Crash extends Component {
  state = { error: null };
  static getDerivedStateFromError(error) { return { error }; }
  componentDidCatch(error, info) { console.error(error, info?.componentStack); }
  componentDidMount() { this.reset = () => this.state.error && this.setState({ error: null }); addEventListener("hashchange", this.reset); }
  componentWillUnmount() { removeEventListener("hashchange", this.reset); }
  render() {
    if (!this.state.error) return this.props.children;
    const Wrap = this.props.page ? "main" : "div";
    return (
      <Wrap className="shell">
        <div className="card warn" role="alert">
          <h2>Щось пішло не так</h2>
          <p>Сторінка не змогла відобразитися. Введені дані чернеток зберігаються на сервері — після оновлення вони будуть на місці.</p>
          <p className="muted small">{String(this.state.error?.message || this.state.error)}</p>
          <div className="actions">
            <button type="button" className="btn" onClick={() => location.reload()}>Оновити сторінку</button>
            <button type="button" className="btn btn-secondary" onClick={() => this.setState({ error: null })}>Спробувати ще раз</button>
          </div>
        </div>
      </Wrap>
    );
  }
}
